<template>
  <div class="cr1224-page">
    <StatusBar v-bind="status" :alarmMsg="alarmMsg" :deviseSn="sn" />
    <div class="chart-area">
      <v-chart
        v-for="(item, index) in chartData"
        :key="index"
        class="chart"
        :options="item"
        :autoresize="true"
      />
    </div>
  </div>
</template>

<script>
import { formatTimestamp } from '@/utils/utils';
import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/echartOption/common';

import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import StatusBar from './components/status-bar.vue';
import { isEmpty } from '@/utils/is';

export default {
  name: 'cr1224',
  mixins: [singleDeviceMixin],
  sockets: {
    '/socket/detail'(res) {
      this.update(res);
    }
  },
  data() {
    const t1 = this.$t('剂量率μSv/h');
    const t2 = this.$t('累积剂量μSv');

    return {
      maxLen: 20,
      alarmMsg: '',
      status: {
        runStateTips: '',
        alarmStatus: 0,
        runstate: 0
      },
      chartData: [
        lineAreaStyle({
          color: ['#833BBB', '#3368F2'],
          legend: {
            top: 'auto',
            right: '5%',
            icon: 'circle',
            orient: 'vertical',
            textStyle: {
              color: '#fff'
            }
          },
          title: { text: t1, left: 'center' },
          yAxis: { type: 'value' },
          xAxis: {
            type: 'category',
            data: []
          },
          series: [
            {
              name: '',
              type: 'line',
              symbol: 'emptyCircle',
              areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') },
              smooth: true,
              data: []
            }
          ]
        }),

        lineAreaStyle({
          color: ['#833BBB', '#3368F2'],
          legend: {
            top: 'auto',
            right: '5%',
            icon: 'circle',
            orient: 'vertical',
            textStyle: {
              color: '#fff'
            }
          },
          title: { text: t2, left: 'center' },
          yAxis: { type: 'value' },
          xAxis: {
            type: 'category',
            data: []
          },
          series: [
            {
              name: '',
              type: 'line',
              symbol: 'emptyCircle',
              areaStyle: { color: graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)') },
              smooth: true,
              data: []
            }
          ]
        })
      ]
    };
  },
  mounted() {
    this.normalColor = graColor('rgb(3, 153, 224)', 'rgba(3, 153, 224, 0.1)');
    this.warinColor = graColor('rgb(250, 96, 100)', 'rgba(250, 96, 100,0.1)');
  },
  methods: {
    langChangeHandler() {
      const titles = ['剂量率μSv/h', '累积剂量μSv'];
      this.chartData.forEach((item, index) => {
        item.title.text = this.$t(titles[index]);
      });
    },
    update(res) {
      const { rg04Dto, alarmContent } = res.mods.nuclearMod;
      this.alarmMsg = alarmContent;
      this.status.runstate = res.runstate;
      this.status.alarmStatus = res.mods.nuclearMod.state;
      this.status.runStateTips = isEmpty(res.faults) ? '' : res.faults[0].faultName;

      this.alarmType = rg04Dto.alarmType;
      //   this.alarmType = 6;

      switch (this.alarmType) {
        case 0:
          // 无报警
          this.chartData.forEach(item => {
            item.series[0].areaStyle.color = this.normalColor;
          });
          break;
        case 1:
          // 模拟报警
          this.chartData.forEach(item => {
            item.series[0].areaStyle.color = this.warinColor;
          });
          break;
        case 2:
          // 剂量报警
          this.chartData[0].series[0].areaStyle.color = this.warinColor;
          this.chartData[1].series[0].areaStyle.color = this.normalColor;

          break;
        case 4:
          // 累积剂量报警
          this.chartData[1].series[0].areaStyle.color = this.warinColor;
          this.chartData[0].series[0].areaStyle.color = this.normalColor;

          break;
        case 6:
          // 剂量报警、累积剂量报警
          this.chartData.forEach(item => {
            item.series[0].areaStyle.color = this.warinColor;
          });
          break;
        default:
          this.chartData.forEach(item => {
            item.series[0].areaStyle.color = this.normalColor;
          });
          break;
      }

      this.chartData[0].xAxis.data.push(formatTimestamp(res.beginTime));
      this.chartData[0].series[0].data.push(rg04Dto.radDose);

      this.chartData[1].xAxis.data.push(formatTimestamp(res.beginTime));
      this.chartData[1].series[0].data.push(rg04Dto.dose);

      if (this.chartData[0].xAxis.data.length > this.maxLen) {
        this.chartData.forEach(item => {
          item.xAxis.data.shift();
          item.series[0].data.shift();
        });
      }
    }
  },
  components: {
    StatusBar
  }
};
</script>

<style lang="scss">
.cr1224-page {
  padding: 10px;
  height: 100%;
  box-sizing: border-box;

  span {
    @include state-textstyle;
  }

  .chart-area {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: calc(100% - 100px);
    .chart {
      border: 1px solid rgb(96, 118, 173) !important;
      height: 90% !important;
      width: 45% !important;
    }
  }
}
</style>
